import { Component, OnInit, AfterViewInit, Output, EventEmitter, Input, ElementRef, ViewChild, HostListener } from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { Notification } from '@api/models/notification';
import { NotificationService } from '@api/services/notification.service';

@Component({
    selector: 'app-notification-modal',
    templateUrl: './notification-modal.component.html',
    styleUrls: ['./notification-modal.component.scss'],
    animations: [
        trigger('expandCollapse', [
            state('collapsed', style({
                height: '0px',
                display: 'none',
            })),
            state('expanded', style({
                height: '*',
            })),
            transition('collapsed <=> expanded', [
                animate(300)
            ])
        ])
    ],
    standalone: false
})
// A11Y-350: ajustes de accesibilidad
export class NotificationModalComponent implements OnInit, AfterViewInit {
  @Input() head?;
  @Input() notifications?: Notification[];
  @Output() hide = new EventEmitter<void>();
  @Output() redirect = new EventEmitter<void>();
  @ViewChild('modalTitle') modalTitle: ElementRef;
  @ViewChild('emptyStateAction') emptyStateAction: ElementRef;

  constructor(private notificationService: NotificationService) {}

  ngOnInit(): void {
    this.notificationService.sortNotificationsByPriority();
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      if (this.emptyStateAction) {
        this.emptyStateAction.nativeElement.focus();
      } else if (this.modalTitle) {
        this.modalTitle.nativeElement.focus();
      }
    }, 100);
  }

  toggleNotification(index: number) {
    if (this.notifications[index].text) {
      this.notifications[index].expanded = !this.notifications[index].expanded;
    }
  }

  @HostListener('document:keydown.escape')
  onEscapeKey() {
    this.hide.emit();
  }
}
